module.exports = __webpack_public_path__ + "static/media/chess-pawn-alt.7e582477.svg";